import FormSubmitter from '@/zenky/forms/FormSubmitter';
import AbstractForm from '@/zenky/forms/AbstractForm';
import ProductVariantDataTransformer from '@/resources/products/variants/ProductVariantDataTransformer';

export default class EditProductVariantFormSubmitter extends FormSubmitter {
  protected transformValues(form: AbstractForm): any {
    return new ProductVariantDataTransformer().transformVariant(form.values.values());
  }
}
